/** Trim to non-empty string, or "". */
function trimVal(v) {
  if (v == null) return "";
  const s = String(v).trim();
  return s;
}

/** City label from nested `city` or flat `ci_name` (API variants). */
function cityNameFrom(customer) {
  if (!customer) return "";
  return (
    trimVal(customer.city?.ci_name) ||
    trimVal(customer.ci_name) ||
    trimVal(customer.city_name) ||
    (typeof customer.city === "string" ? trimVal(customer.city) : "")
  );
}

/** Street / detail address. */
function addressFrom(customer) {
  if (!customer) return "";
  return trimVal(customer.cu_address) || trimVal(customer.address);
}

/** Customer phone (API variants). */
function phoneFrom(customer) {
  if (!customer) return "";
  return (
    trimVal(customer.cu_phone) ||
    trimVal(customer.phone) ||
    trimVal(customer.phone_number) ||
    trimVal(customer.customer_phone_number)
  );
}

/**
 * Plain text line for A4: "City - Address - Phone", or available parts, or placeholder.
 * Merges invoice `customer` with optional row from `customer.customers` (or EditSale selected row)
 * so missing fields on one payload still print when the other has them.
 */
export function getInvoiceCustomerCityAddressPlainLine(
  invoiceCustomer,
  storeCustomer,
  placeholderPlain
) {
  const id = invoiceCustomer?.cu_id ?? storeCustomer?.cu_id;
  if (id == null || id === "") {
    return placeholderPlain;
  }

  const city =
    cityNameFrom(invoiceCustomer) ||
    cityNameFrom(storeCustomer);

  const addr =
    addressFrom(invoiceCustomer) ||
    addressFrom(storeCustomer);

  const phone =
    phoneFrom(invoiceCustomer) ||
    phoneFrom(storeCustomer);

  const parts = [city, addr, phone].filter(Boolean);
  if (parts.length > 0) return parts.join(" - ");
  return placeholderPlain;
}

export function escapeInvoiceA4Text(str) {
  if (str == null) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * Safe HTML fragment for invoice header (escaped).
 */
export function getEscapedInvoiceCustomerCityAddressLine(
  invoiceCustomer,
  storeCustomer,
  placeholderPlain
) {
  const plain = getInvoiceCustomerCityAddressPlainLine(
    invoiceCustomer,
    storeCustomer,
    placeholderPlain
  );
  return escapeInvoiceA4Text(plain);
}

/**
 * When API sends `ci_id` but no nested `city.ci_name`, resolve name from `cityRows`
 * (e.g. `sale_city.citys` from `city/get-citys`).
 */
export function enrichCustomerCityFromRows(customer, cityRows) {
  if (!customer) return customer;
  const hasCityName =
    trimVal(customer.city?.ci_name) ||
    trimVal(customer.ci_name);
  if (hasCityName) return customer;
  const ciId = customer.ci_id ?? customer.city?.ci_id;
  if (ciId == null || ciId === "") return customer;
  const rows = cityRows || [];
  const hit = rows.find((r) => String(r.ci_id) === String(ciId));
  if (!hit) return customer;
  return {
    ...customer,
    city: {
      ...(customer.city && typeof customer.city === "object" ? customer.city : {}),
      ci_id: hit.ci_id,
      ci_name: hit.ci_name,
    },
  };
}
